<template>
  <div class="px-10 py-4 md:px-8 sm:px-6">
    <div class="flex flex-wrap gap-x-4 gap-y-2 items-baseline mb-12">
      <h1 class="flex-shrink-0 text-2xl text-black">一起訂東西</h1>
      <p class="text-gray-500">
        中午團訂餐盒，下午齊訂手搖，禮盒、水果、還是日用品，想買什麼約什麼，輕輕鬆鬆揪團買！
      </p>
    </div>
    <div class="bg-white p-4">
      <order-search
        v-model="search"
        :dates="dates"
        :date-type="dateType"
        :loading="loading"
        @clear="onClearSearch"
        @search="onSearch"
        @updated-dates="onDatesUpdates"
        @updated-date-type="onDateTypeUpdated"
      />
      <div class="flex flex-wrap gap-4 items-center justify-between mb-6">
        <b-tabs
          v-model="currentTab"
          class="mb-0 overflow-hidden overflow-x-auto"
          type="is-toggle"
        >
          <b-tab-item
            v-for="tab in tabs"
            :disabled="loading"
            :key="`tab-${tab.label}`"
            :label="Number.isInteger(tab.total) ? `${tab.label}(${tab.total})` : tab.label"
            :value="tab.value"
          />
        </b-tabs>
        <div class="flex gap-6">
          <w-button :disabled="loading" size="sm" type="outlined" @click="onShowScheduleList">
            <i class="icon-order" />
            <span class="ml-2">例行性訂購排程</span>
          </w-button>
          <w-button :disabled="loading" size="sm" @click="onCreateNew">
            <i class="icon-plus" />
            <span class="ml-2">發起訂購</span>
          </w-button>
        </div>
      </div>
      <order-list
        :current-page="page"
        :current-per-page="perPage"
        :current-tab="currentTab"
        :loading="loading"
        :orders="orders"
        :sort-field="sortField"
        :sort-order="sortOrder"
        @sort="onSort"
      />
      <div v-if="total && !loading" class="flex gap-4 items-center">
        <b-select v-model="perPage">
          <option
            v-for="option in perPageOptions"
            :value="option.value"
            :key="option.label"
          >
            {{ option.label }}
          </option>
        </b-select>
        <div class="flex-grow">
          <b-pagination
            :total="total"
            v-model="page"
            range-before="3"
            range-after="1"
            nextIcon="right-chevron"
            prevIcon="left-chevron"
            :per-page="perPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderList from './OrderList';

export default OrderList;
</script>

<style lang="scss" scoped>
@import './OrderList';
</style>
